import ErrorPage from '../components/common/ErrorPage.vue'

const systemRoutes = [
  {
    path: '/internal-error',
    name: 'internal-error',
    component: ErrorPage,
    props: {
      title: 'error.internal_error_title',
      legend: 'error.internal_error_description',
      buttonGoHome: true,
    }
  },
  {
    path: '/session-error',
    name: 'session-error',
    component: ErrorPage,
    props: {
      title: 'error.session_error_title',
      legend: 'error.session_error_description',
      imageComponentName: 'Error403',
      buttonGoHome: true,
    }
  },
  {
    path: '/application-error',
    name: 'application-error',
    component: ErrorPage,
    props: true
  },
  {
    path: '/booking-alert',
    name: 'booking-alert',
    component: ErrorPage,
    props: true
  },
  {
    path: '*',
    name: 'not-found',
    component: ErrorPage,
    props: {
      title: 'error.not_found_error_title',
      legend: 'error.not_found_error_description',
      buttonGoHome: true,
    }
  }
]

export { systemRoutes }
